// QR Kiosk v2 — per-surface load-state selector hook (KV2-5). Reads the additive
// kioskV2.loadState map (fulfilled-key + rejected-key, written by the slice) and the
// existing lastLoadedAt, keyed against THIS route's scope key. Backs the normative
// 4-branch render tree (data&&failed → cached-dimmed · data → normal · failed → full
// error · else → skeleton) that replaced the two divergent committed patterns.
//
// Caveat: `loadedAt` is surface-level, not key-level — callers only read it inside a
// branch where `loadedForKey` (or the page's data-guard) has already pinned the key,
// so it always refers to the data currently on screen.
import { useAppSelector } from "../../../shared/hooks/sharedHooks";
import { KioskSurface } from "../kioskV2Slice";

export function useSurfaceState(surface: KioskSurface, routeKey?: string) {
  const ls = useAppSelector((s) => s.kioskV2.loadState[surface]);
  const loadedAt = useAppSelector((s) => s.kioskV2.lastLoadedAt[surface]);
  const key = routeKey?.toLowerCase();
  return {
    /** the last settle FOR THIS ROUTE'S KEY was a rejection */
    failed: !!key && ls?.failedKey === key,
    /** the last fulfilled load of this surface was for this route's key (validates unkeyed DTOs) */
    loadedForKey: !!key && ls?.loadedKey === key,
    /** epoch ms of the last fulfilled load of this surface (any key) — cached-at readout */
    loadedAt,
  };
}

export default useSurfaceState;
